import '@/style/theme.scss';
import '@/style/theme.element.scss';
export default {};
